<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">    
            <h2>Configurer le slider</h2>
            
            <table border="1">
                <tr>
                    <th>Position</th>
                    <th>Image</th>
                    <th>Description</th>
                    <th>Texte du bouton</th>
                    <th>Lien</th>
                    <th>Modifier</th>
                </tr>
                <tr v-for="unSlide in lesSlides" :key="unSlide.id">
                    <td>{{ unSlide.id }}</td>
                    <td><img :src="'/games/static/slides/'+unSlide.image_url" width="200"></td>
                    <td>{{ unSlide.description }}</td>
                    <td>{{ unSlide.action_title }}</td>
                    <td><a :href="unSlide.action_url" target="_blank">{{ unSlide.action_url }}</a></td>
                    <td><router-link :to="'editSlide/'+unSlide.id"><i class="fas fa-edit"></i></router-link></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: 'AdminEditSlider',
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                lesSlides: []
            }
        },
        methods: {
            getSlides() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1"}));
                
                axios
                .post(
                this.$store.state.apiUrl+"?request=getSlides", formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.lesSlides = response.data;
                    }
                });
            }
        },
        mounted() {
            this.getSlides();
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
